import {ValueObject} from '@s-ui/domain'

export class MakeModelValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {String} deps.make
   * @param {String} deps.model
   **/
}
